export default __webpack_public_path__ + "static/media/ReWORX-BrandLogo.c5de82bd.png";